import { render, staticRenderFns } from "./EmployeeLeaveSummaries.vue?vue&type=template&id=754ac4ce&scoped=true"
import script from "./EmployeeLeaveSummaries.vue?vue&type=script&lang=js"
export * from "./EmployeeLeaveSummaries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754ac4ce",
  null
  
)

export default component.exports